export default "__VITE_ASSET__B4noY7CS__"